var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-row",
    {
      directives: [
        {
          name: "scroll",
          rawName: "v-scroll",
          value: _vm.onScroll,
          expression: "onScroll",
        },
      ],
      staticClass: "pb-10",
    },
    [
      _c("mini-header", {
        attrs: {
          breadcrumbs: _vm.breadcrumbs,
          hiddenTab: true,
          dense: true,
          scroll: _vm.scroll,
        },
        scopedSlots: _vm._u([
          {
            key: "main",
            fn: function () {
              return [
                _c(
                  "v-btn",
                  {
                    staticClass: "mr-2",
                    attrs: { outlined: "" },
                    on: { click: _vm.updatedView },
                  },
                  [
                    _c("v-img", {
                      attrs: {
                        contain: "",
                        src: require(`@/assets/icon-update${
                          _vm.$vuetify.theme.dark ? "-dark" : ""
                        }.svg`),
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "v-menu",
                  {
                    attrs: {
                      "close-on-click": "",
                      "close-on-content-click": "",
                      "offset-y": "",
                      left: "",
                      "nudge-bottom": 10,
                      transition: "slide-y-transition",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "activator",
                        fn: function ({ on, attrs }) {
                          return [
                            _c(
                              "v-btn",
                              _vm._g(
                                _vm._b(
                                  {
                                    staticClass: "ml-2",
                                    attrs: { color: "grey-900" },
                                  },
                                  "v-btn",
                                  attrs,
                                  false
                                ),
                                on
                              ),
                              [
                                _c("v-icon", { attrs: { left: "" } }, [
                                  _vm._v("mdi-calendar-blank "),
                                ]),
                                _vm._v(_vm._s(_vm.filter[_vm.selected])),
                                _c(
                                  "v-icon",
                                  { attrs: { size: "18", right: "" } },
                                  [_vm._v("mdi-chevron-down")]
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  },
                  [
                    _c(
                      "v-list",
                      { staticClass: "pa-0" },
                      [
                        _c(
                          "v-list-item",
                          {
                            staticClass: "px-3",
                            attrs: { ripple: false },
                            on: {
                              click: function ($event) {
                                _vm.selected = "this_day"
                              },
                            },
                          },
                          [
                            _c(
                              "v-list-item-title",
                              { staticClass: "body-2 grey-500--text" },
                              [_vm._v("Hoy")]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "v-list-item",
                          {
                            staticClass: "px-3",
                            attrs: { ripple: false },
                            on: {
                              click: function ($event) {
                                _vm.selected = "last_day"
                              },
                            },
                          },
                          [
                            _c(
                              "v-list-item-title",
                              { staticClass: "body-2 grey-500--text" },
                              [_vm._v("Ayer")]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "v-list-item",
                          {
                            staticClass: "px-3",
                            attrs: { ripple: false },
                            on: {
                              click: function ($event) {
                                _vm.selected = "this_week"
                              },
                            },
                          },
                          [
                            _c(
                              "v-list-item-title",
                              { staticClass: "body-2 grey-500--text" },
                              [_vm._v("Esta semana")]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "v-list-item",
                          {
                            staticClass: "px-3",
                            attrs: { ripple: false },
                            on: {
                              click: function ($event) {
                                _vm.selected = "last_week"
                              },
                            },
                          },
                          [
                            _c(
                              "v-list-item-title",
                              { staticClass: "body-2 grey-500--text" },
                              [_vm._v("Semana pasada")]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "v-list-item",
                          {
                            staticClass: "px-3",
                            attrs: { ripple: false },
                            on: {
                              click: function ($event) {
                                _vm.selected = "this_month"
                              },
                            },
                          },
                          [
                            _c(
                              "v-list-item-title",
                              { staticClass: "body-2 grey-500--text" },
                              [_vm._v("Este mes")]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "v-list-item",
                          {
                            staticClass: "px-3",
                            attrs: { ripple: false },
                            on: {
                              click: function ($event) {
                                _vm.selected = "last_month"
                              },
                            },
                          },
                          [
                            _c(
                              "v-list-item-title",
                              { staticClass: "body-2 grey-500--text" },
                              [_vm._v("Mes pasado")]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c(
        "v-col",
        { staticClass: "pa-0" },
        [
          _c(
            "v-row",
            { attrs: { "no-gutters": "" } },
            [
              _c(
                "v-col",
                [
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "4" } },
                        [
                          _c("v-hover", {
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function ({ hover }) {
                                  return [
                                    _c(
                                      "v-card",
                                      {
                                        class: [`pa-4 rounded-md`],
                                        attrs: {
                                          elevation: hover
                                            ? 5
                                            : _vm.selected === "this_day"
                                            ? 8
                                            : 0,
                                        },
                                        on: {
                                          click: function ($event) {
                                            _vm.selected = "this_day"
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "v-col",
                                          { staticClass: "text-center pa-0" },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "text-subtitle-2 grey-700--text",
                                              },
                                              [_vm._v("Hoy")]
                                            ),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "d-block mt-2 font-weight-bold text-h4 grey-700--text",
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$fmt.integer(
                                                        (_vm.cards?.this_day
                                                          ?.OBS ?? 0) +
                                                          (_vm.cards?.this_day
                                                            ?.APR ?? 0) +
                                                          (_vm.cards?.this_day
                                                            ?.REJ ?? 0) +
                                                          (_vm.cards?.this_day
                                                            ?.DUP ?? 0)
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _c("div", [
                                          _c(
                                            "span",
                                            { staticClass: "d-block pt-2" },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  class: [
                                                    `green-500--text font-weight-bold mr-1`,
                                                    _vm.$vuetify.breakpoint
                                                      .width <= 1250
                                                      ? "text-body-1"
                                                      : "text-h6",
                                                  ],
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$fmt.integer(
                                                        (_vm.cards?.this_day
                                                          ?.OBS ?? 0) +
                                                          (_vm.cards?.this_day
                                                            ?.APR ?? 0)
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "span",
                                                {
                                                  class:
                                                    _vm.$vuetify.breakpoint
                                                      .width <= 1250
                                                      ? "text-body-1"
                                                      : "text-subtitle-2",
                                                },
                                                [_vm._v("Aceptados")]
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "span",
                                            { staticClass: "d-block" },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  class: [
                                                    `red-500--text font-weight-bold mr-1`,
                                                    _vm.$vuetify.breakpoint
                                                      .width <= 1250
                                                      ? "text-body-1"
                                                      : "text-h6",
                                                  ],
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$fmt.integer(
                                                        (_vm.cards?.this_day
                                                          ?.REJ ?? 0) +
                                                          (_vm.cards?.this_day
                                                            ?.DUP ?? 0)
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "span",
                                                {
                                                  class:
                                                    _vm.$vuetify.breakpoint
                                                      .width <= 1250
                                                      ? "text-body-1"
                                                      : "text-subtitle-2",
                                                },
                                                [_vm._v("Rechazados")]
                                              ),
                                            ]
                                          ),
                                        ]),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "4" } },
                        [
                          _c("v-hover", {
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function ({ hover }) {
                                  return [
                                    _c(
                                      "v-card",
                                      {
                                        class: [`pa-4 rounded-md`],
                                        attrs: {
                                          elevation: hover
                                            ? 5
                                            : _vm.selected === "this_week"
                                            ? 8
                                            : 0,
                                          flat: "",
                                        },
                                        on: {
                                          click: function ($event) {
                                            _vm.selected = "this_week"
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "v-col",
                                          { staticClass: "text-center pa-0" },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "text-subtitle-2 grey-700--text",
                                              },
                                              [_vm._v("Esta semana")]
                                            ),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "d-block mt-2 font-weight-bold text-h4 grey-700--text",
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$fmt.integer(
                                                        (_vm.cards?.this_week
                                                          ?.OBS ?? 0) +
                                                          (_vm.cards?.this_week
                                                            ?.APR ?? 0) +
                                                          (_vm.cards?.this_week
                                                            ?.REJ ?? 0) +
                                                          (_vm.cards?.this_week
                                                            ?.DUP ?? 0)
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _c("div", [
                                          _c(
                                            "span",
                                            { staticClass: "d-block pt-2" },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  class: [
                                                    `green-500--text font-weight-bold mr-1`,
                                                    _vm.$vuetify.breakpoint
                                                      .width <= 1250
                                                      ? "text-body-1"
                                                      : "text-h6",
                                                  ],
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$fmt.integer(
                                                        (_vm.cards?.this_week
                                                          ?.OBS ?? 0) +
                                                          (_vm.cards?.this_week
                                                            ?.APR ?? 0)
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "span",
                                                {
                                                  class:
                                                    _vm.$vuetify.breakpoint
                                                      .width <= 1250
                                                      ? "text-body-1"
                                                      : "text-subtitle-2",
                                                },
                                                [_vm._v("Aceptados")]
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "span",
                                            { staticClass: "d-block" },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  class: [
                                                    `red-500--text font-weight-bold mr-1`,
                                                    _vm.$vuetify.breakpoint
                                                      .width <= 1250
                                                      ? "text-body-1"
                                                      : "text-h6",
                                                  ],
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$fmt.integer(
                                                        (_vm.cards?.this_week
                                                          ?.REJ ?? 0) +
                                                          (_vm.cards?.this_week
                                                            ?.DUP ?? 0)
                                                      )
                                                    ) + " "
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "span",
                                                {
                                                  class:
                                                    _vm.$vuetify.breakpoint
                                                      .width <= 1250
                                                      ? "text-body-1"
                                                      : "text-subtitle-2",
                                                },
                                                [_vm._v("Rechazados")]
                                              ),
                                            ]
                                          ),
                                        ]),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "4" } },
                        [
                          _c("v-hover", {
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function ({ hover }) {
                                  return [
                                    _c(
                                      "v-card",
                                      {
                                        class: [`pa-4 rounded-md`],
                                        attrs: {
                                          elevation: hover
                                            ? 5
                                            : _vm.selected === "this_month"
                                            ? 8
                                            : 0,
                                          flat: "",
                                        },
                                        on: {
                                          click: function ($event) {
                                            _vm.selected = "this_month"
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "v-col",
                                          { staticClass: "text-center pa-0" },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "text-subtitle-2 grey-700--text",
                                              },
                                              [_vm._v("Este mes")]
                                            ),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "d-block mt-2 font-weight-bold text-h4 grey-700--text",
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$fmt.integer(
                                                        (_vm.cards?.this_month
                                                          ?.OBS ?? 0) +
                                                          (_vm.cards?.this_month
                                                            ?.APR ?? 0) +
                                                          (_vm.cards?.this_month
                                                            ?.REJ ?? 0) +
                                                          (_vm.cards?.this_month
                                                            ?.DUP ?? 0)
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _c("div", [
                                          _c(
                                            "span",
                                            { staticClass: "d-block pt-2" },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  class: [
                                                    `green-500--text font-weight-bold mr-1`,
                                                    _vm.$vuetify.breakpoint
                                                      .width <= 1250
                                                      ? "text-body-1"
                                                      : "text-h6",
                                                  ],
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$fmt.integer(
                                                        (_vm.cards?.this_month
                                                          ?.OBS ?? 0) +
                                                          (_vm.cards?.this_month
                                                            ?.APR ?? 0)
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "span",
                                                {
                                                  class:
                                                    _vm.$vuetify.breakpoint
                                                      .width <= 1250
                                                      ? "text-body-1"
                                                      : "text-subtitle-2",
                                                },
                                                [_vm._v("Aceptados")]
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "span",
                                            { staticClass: "d-block" },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  class: [
                                                    `red-500--text font-weight-bold mr-1`,
                                                    _vm.$vuetify.breakpoint
                                                      .width <= 1250
                                                      ? "text-body-1"
                                                      : "text-h6",
                                                  ],
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$fmt.integer(
                                                        (_vm.cards?.this_month
                                                          ?.REJ ?? 0) +
                                                          (_vm.cards?.this_month
                                                            ?.DUP ?? 0)
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "span",
                                                {
                                                  class:
                                                    _vm.$vuetify.breakpoint
                                                      .width <= 1250
                                                      ? "text-body-1"
                                                      : "text-subtitle-2",
                                                },
                                                [_vm._v("Rechazados")]
                                              ),
                                            ]
                                          ),
                                        ]),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "4" } },
                        [
                          _c("v-hover", {
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function ({ hover }) {
                                  return [
                                    _c(
                                      "v-card",
                                      {
                                        class: [`pa-4 rounded-md`],
                                        attrs: {
                                          elevation: hover
                                            ? 5
                                            : _vm.selected === "last_day"
                                            ? 8
                                            : 0,
                                          flat: "",
                                        },
                                        on: {
                                          click: function ($event) {
                                            _vm.selected = "last_day"
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "v-col",
                                          { staticClass: "text-center pa-0" },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "text-subtitle-2 grey-700--text",
                                              },
                                              [_vm._v("Ayer")]
                                            ),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "d-block mt-2 font-weight-bold text-h4 grey-700--text",
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$fmt.integer(
                                                        (_vm.cards?.last_day
                                                          ?.OBS ?? 0) +
                                                          (_vm.cards?.last_day
                                                            ?.APR ?? 0) +
                                                          (_vm.cards?.last_day
                                                            ?.REJ ?? 0) +
                                                          (_vm.cards?.last_day
                                                            ?.DUP ?? 0)
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _c("div", [
                                          _c(
                                            "span",
                                            { staticClass: "d-block pt-2" },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  class: [
                                                    `green-500--text font-weight-bold mr-1`,
                                                    _vm.$vuetify.breakpoint
                                                      .width <= 1250
                                                      ? "text-body-1"
                                                      : "text-h6",
                                                  ],
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$fmt.integer(
                                                        (_vm.cards?.last_day
                                                          ?.OBS ?? 0) +
                                                          (_vm.cards?.last_day
                                                            ?.APR ?? 0)
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "span",
                                                {
                                                  class:
                                                    _vm.$vuetify.breakpoint
                                                      .width <= 1250
                                                      ? "text-body-1"
                                                      : "text-subtitle-2",
                                                },
                                                [_vm._v("Aceptados")]
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "span",
                                            { staticClass: "d-block" },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  class: [
                                                    `red-500--text font-weight-bold mr-1`,
                                                    _vm.$vuetify.breakpoint
                                                      .width <= 1250
                                                      ? "text-body-1"
                                                      : "text-h6",
                                                  ],
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$fmt.integer(
                                                        (_vm.cards?.last_day
                                                          ?.REJ ?? 0) +
                                                          (_vm.cards?.last_day
                                                            ?.DUP ?? 0)
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "span",
                                                {
                                                  class:
                                                    _vm.$vuetify.breakpoint
                                                      .width <= 1250
                                                      ? "text-body-1"
                                                      : "text-subtitle-2",
                                                },
                                                [_vm._v("Rechazados")]
                                              ),
                                            ]
                                          ),
                                        ]),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "4" } },
                        [
                          _c("v-hover", {
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function ({ hover }) {
                                  return [
                                    _c(
                                      "v-card",
                                      {
                                        class: [`pa-4 rounded-md`],
                                        attrs: {
                                          elevation: hover
                                            ? 5
                                            : _vm.selected === "last_week"
                                            ? 8
                                            : 0,
                                          flat: "",
                                        },
                                        on: {
                                          click: function ($event) {
                                            _vm.selected = "last_week"
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "v-col",
                                          { staticClass: "text-center pa-0" },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "text-subtitle-2 grey-700--text",
                                              },
                                              [_vm._v("Semana pasada")]
                                            ),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "d-block mt-2 font-weight-bold text-h4 grey-700--text",
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$fmt.integer(
                                                        (_vm.cards?.last_week
                                                          ?.OBS ?? 0) +
                                                          (_vm.cards?.last_week
                                                            ?.APR ?? 0) +
                                                          (_vm.cards?.last_week
                                                            ?.REJ ?? 0) +
                                                          (_vm.cards?.last_week
                                                            ?.DUP ?? 0)
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _c("div", [
                                          _c(
                                            "span",
                                            { staticClass: "d-block pt-2" },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  class: [
                                                    `green-500--text font-weight-bold mr-1`,
                                                    _vm.$vuetify.breakpoint
                                                      .width <= 1250
                                                      ? "text-body-1"
                                                      : "text-h6",
                                                  ],
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$fmt.integer(
                                                        (_vm.cards?.last_week
                                                          ?.OBS ?? 0) +
                                                          (_vm.cards?.last_week
                                                            ?.APR ?? 0)
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "span",
                                                {
                                                  class:
                                                    _vm.$vuetify.breakpoint
                                                      .width <= 1250
                                                      ? "text-body-1"
                                                      : "text-subtitle-2",
                                                },
                                                [_vm._v("Aceptados")]
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "span",
                                            { staticClass: "d-block" },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  class: [
                                                    `red-500--text font-weight-bold mr-1`,
                                                    _vm.$vuetify.breakpoint
                                                      .width <= 1250
                                                      ? "text-body-1"
                                                      : "text-h6",
                                                  ],
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$fmt.integer(
                                                        (_vm.cards?.last_week
                                                          ?.REJ ?? 0) +
                                                          (_vm.cards?.last_week
                                                            ?.DUP ?? 0)
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "span",
                                                {
                                                  class:
                                                    _vm.$vuetify.breakpoint
                                                      .width <= 1250
                                                      ? "text-body-1"
                                                      : "text-subtitle-2",
                                                },
                                                [_vm._v("Rechazados")]
                                              ),
                                            ]
                                          ),
                                        ]),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "4" } },
                        [
                          _c("v-hover", {
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function ({ hover }) {
                                  return [
                                    _c(
                                      "v-card",
                                      {
                                        class: [`pa-4 rounded-md`],
                                        attrs: {
                                          elevation: hover
                                            ? 5
                                            : _vm.selected === "last_month"
                                            ? 8
                                            : 0,
                                          flat: "",
                                        },
                                        on: {
                                          click: function ($event) {
                                            _vm.selected = "last_month"
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "v-col",
                                          { staticClass: "text-center pa-0" },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "text-subtitle-2 grey-700--text",
                                              },
                                              [_vm._v("Mes pasado")]
                                            ),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "d-block mt-2 font-weight-bold text-h4 grey-700--text",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$fmt.integer(
                                                      (_vm.cards?.last_month
                                                        ?.OBS ?? 0) +
                                                        (_vm.cards?.last_month
                                                          ?.APR ?? 0) +
                                                        (_vm.cards?.last_month
                                                          ?.REJ ?? 0) +
                                                        (_vm.cards?.last_month
                                                          ?.DUP ?? 0)
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _c("div", [
                                          _c(
                                            "span",
                                            { staticClass: "d-block pt-2" },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  class: [
                                                    `green-500--text font-weight-bold mr-1`,
                                                    _vm.$vuetify.breakpoint
                                                      .width <= 1250
                                                      ? "text-body-1"
                                                      : "text-h6",
                                                  ],
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$fmt.integer(
                                                        (_vm.cards?.last_month
                                                          ?.OBS ?? 0) +
                                                          (_vm.cards?.last_month
                                                            ?.APR ?? 0)
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "span",
                                                {
                                                  class:
                                                    _vm.$vuetify.breakpoint
                                                      .width <= 1250
                                                      ? "text-body-1"
                                                      : "text-subtitle-2",
                                                },
                                                [_vm._v("Aceptados")]
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "span",
                                            { staticClass: "d-block" },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  class: [
                                                    `red-500--text font-weight-bold mr-1`,
                                                    _vm.$vuetify.breakpoint
                                                      .width <= 1250
                                                      ? "text-body-1"
                                                      : "text-h6",
                                                  ],
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$fmt.integer(
                                                        (_vm.cards?.last_month
                                                          ?.REJ ?? 0) +
                                                          (_vm.cards?.last_month
                                                            ?.DUP ?? 0)
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "span",
                                                {
                                                  class:
                                                    _vm.$vuetify.breakpoint
                                                      .width <= 1250
                                                      ? "text-body-1"
                                                      : "text-subtitle-2",
                                                },
                                                [_vm._v("Rechazados")]
                                              ),
                                            ]
                                          ),
                                        ]),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-col",
                { staticClass: "pl-6", attrs: { cols: "4" } },
                [
                  _c(
                    "v-card",
                    { attrs: { flat: "" } },
                    [
                      _c(
                        "v-card-title",
                        { staticClass: "pa-0" },
                        [
                          _c(
                            "v-toolbar",
                            {
                              attrs: {
                                color: "transparent",
                                flat: "",
                                height: "46",
                              },
                            },
                            [
                              _c(
                                "v-toolbar-title",
                                {
                                  staticClass:
                                    "px-5 d-flex align-center subtitle-2 grey-500--text font-weight-semibold",
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: {
                                        left: "",
                                        color: "grey-700",
                                        size: "20",
                                      },
                                    },
                                    [_vm._v("mdi-chart-bar")]
                                  ),
                                  _vm._v("Documentos procesados"),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("v-divider"),
                      _c(
                        "v-card-text",
                        { staticClass: "py-4 px-4" },
                        [
                          _c(
                            "v-card",
                            { attrs: { flat: "", outlined: "" } },
                            [
                              _c(
                                "v-card-text",
                                {
                                  style:
                                    _vm.$vuetify.breakpoint.width < 1250
                                      ? "min-height: 70px"
                                      : "",
                                },
                                [
                                  _c("div", { staticClass: "d-flex" }, [
                                    _c(
                                      "div",
                                      [
                                        _c("v-avatar", {
                                          staticClass: "mr-1",
                                          attrs: { color: "grey-900", size: 8 },
                                        }),
                                        _vm._v(" Aceptado "),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "ml-5" },
                                      [
                                        _c("v-avatar", {
                                          staticClass: "mr-1",
                                          attrs: { color: "red-500", size: 8 },
                                        }),
                                        _vm._v(" Rechazado "),
                                      ],
                                      1
                                    ),
                                  ]),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "text-center",
                                      class: [
                                        `pt-5`,
                                        _vm.$vuetify.breakpoint.width < 1250
                                          ? "pb-0"
                                          : "pb-5",
                                      ],
                                    },
                                    [
                                      _vm.loading
                                        ? _c("v-progress-circular", {
                                            attrs: {
                                              size: 180,
                                              width: 25,
                                              indeterminate: "",
                                              color: "grey-50",
                                            },
                                          })
                                        : [
                                            _c("chart-doughnut", {
                                              staticClass: "doughnut",
                                              attrs: {
                                                "chart-data":
                                                  _vm.totalDonut() >= 1
                                                    ? _vm.chartDonut
                                                    : _vm.chartDonutEmpty,
                                                colors:
                                                  _vm.totalDonut() > 1
                                                    ? ["#48E264", "#BE2D2F"]
                                                    : ["#F4F6FA", "#F4F6FA"],
                                                tooltips: _vm.totalDonut() >= 1,
                                                height:
                                                  _vm.$vuetify.breakpoint
                                                    .width < 1250
                                                    ? 170
                                                    : 180,
                                              },
                                            }),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "doughnut__text-doughnut text-center text-h5 grey-700--text font-weight-bold",
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.totalDonut(true)
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ],
                                    ],
                                    2
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-row",
            [
              _c(
                "v-col",
                { attrs: { cols: "6" } },
                [
                  _c(
                    "v-card",
                    { attrs: { height: 450, flat: "" } },
                    [
                      _c(
                        "v-card-title",
                        { staticClass: "pa-0" },
                        [
                          _c(
                            "v-toolbar",
                            {
                              attrs: {
                                color: "transparent",
                                flat: "",
                                height: "46",
                              },
                            },
                            [
                              _c(
                                "v-toolbar-title",
                                {
                                  staticClass:
                                    "px-5 d-flex align-center subtitle-2 grey-500--text font-weight-semibold",
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: {
                                        left: "",
                                        color: "grey-700",
                                        size: "20",
                                      },
                                    },
                                    [_vm._v("mdi-file-document-multiple")]
                                  ),
                                  _vm._v("Tipo de documentos "),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("v-divider"),
                      _c(
                        "v-card-text",
                        { staticClass: "pa-0" },
                        [
                          _vm.loading
                            ? _c("skeleton-list")
                            : [
                                !_vm.documents.length
                                  ? _c("v-empty-state", {
                                      staticClass: "mt-16 pt-10",
                                      attrs: {
                                        type: "documents",
                                        id: "documentos",
                                        customClass: "mt-1",
                                        isFree: true,
                                        title:
                                          "Aún no tienes documentos para mostrar",
                                        height: 160,
                                        minHeight: "200",
                                      },
                                    })
                                  : _c("v-simple-table", {
                                      staticClass: "no-hover table-not-rounded",
                                      attrs: { dense: "" },
                                      scopedSlots: _vm._u([
                                        {
                                          key: "default",
                                          fn: function () {
                                            return [
                                              _c(
                                                "thead",
                                                [
                                                  _c("tr", [
                                                    _c(
                                                      "th",
                                                      {
                                                        staticClass:
                                                          "text-left grey-700--text font-weight-medium",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Tipo de documento"
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "th",
                                                      {
                                                        staticClass:
                                                          "text-end grey-700--text font-weight-medium",
                                                        staticStyle: {
                                                          "min-width": "40px",
                                                        },
                                                      },
                                                      [_vm._v("Aceptados")]
                                                    ),
                                                    _c(
                                                      "th",
                                                      {
                                                        staticClass:
                                                          "text-end grey-700--text font-weight-medium",
                                                        staticStyle: {
                                                          "min-width": "40px",
                                                        },
                                                      },
                                                      [_vm._v("Rechazados")]
                                                    ),
                                                    _c(
                                                      "th",
                                                      {
                                                        staticClass:
                                                          "text-end grey-700--text font-weight-medium",
                                                        staticStyle: {
                                                          "min-width": "50px",
                                                        },
                                                      },
                                                      [_vm._v("Total")]
                                                    ),
                                                  ]),
                                                  _c("v-divider", {
                                                    staticStyle: {
                                                      position: "absolute",
                                                      "margin-top": "-6px",
                                                      "min-width": "100%",
                                                      "margin-left": "-8px",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "tbody",
                                                _vm._l(
                                                  _vm.documents,
                                                  function (item) {
                                                    return _c(
                                                      "tr",
                                                      { key: item.id },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "body-2",
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "d-inline-block text-truncate ml-n1",
                                                                staticStyle: {
                                                                  "max-width":
                                                                    "100%",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm._f(
                                                                      "nameDocumentsType"
                                                                    )(item.code)
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "text-end body-2",
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  _vm.$fmt.integer(
                                                                    item.totalA
                                                                  )
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "text-end body-2",
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  _vm.$fmt.integer(
                                                                    item.totalR
                                                                  )
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "text-end body-2",
                                                            staticStyle: {
                                                              "min-width":
                                                                "180px",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  _vm.$fmt.integer(
                                                                    item.totalA +
                                                                      item.totalR
                                                                  )
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    )
                                                  }
                                                ),
                                                0
                                              ),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ]),
                                    }),
                              ],
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { cols: "6" } },
                [
                  _c(
                    "v-card",
                    { attrs: { flat: "", height: 450 } },
                    [
                      _c(
                        "v-card-title",
                        { staticClass: "pa-0" },
                        [
                          _c(
                            "v-toolbar",
                            {
                              attrs: {
                                color: "transparent",
                                flat: "",
                                height: "46",
                              },
                            },
                            [
                              _c(
                                "v-toolbar-title",
                                {
                                  staticClass:
                                    "px-5 d-flex align-center subtitle-2 grey-500--text font-weight-semibold",
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: {
                                        left: "",
                                        color: "grey-700",
                                        size: "20",
                                      },
                                    },
                                    [_vm._v("mdi-chart-bar")]
                                  ),
                                  _vm._v("Métricas de los tipo de documentos"),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("v-divider"),
                      _c(
                        "v-card-text",
                        { staticClass: "pt-4 pb-0 px-4" },
                        [
                          _c(
                            "v-card",
                            { attrs: { flat: "", outlined: "" } },
                            [
                              _c(
                                "v-card-text",
                                {
                                  style:
                                    _vm.$vuetify.breakpoint.width < 1250
                                      ? "min-height: 70px"
                                      : "",
                                },
                                [
                                  _c("div", { staticClass: "d-flex" }, [
                                    _c(
                                      "div",
                                      [
                                        _c("v-avatar", {
                                          staticClass: "mr-1",
                                          attrs: { color: "grey-900", size: 8 },
                                        }),
                                        _vm._v(" Aceptado "),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "ml-5" },
                                      [
                                        _c("v-avatar", {
                                          staticClass: "mr-1",
                                          attrs: { color: "red-500", size: 8 },
                                        }),
                                        _vm._v(" Rechazado "),
                                      ],
                                      1
                                    ),
                                  ]),
                                  _c(
                                    "v-col",
                                    { staticClass: "pt-5 pb-0" },
                                    [
                                      _c("chart-bar", {
                                        staticClass: "d-block mt-4",
                                        staticStyle: { position: "relative" },
                                        attrs: {
                                          "chart-data": _vm.chartBarData,
                                          height: 285,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }